import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";

import { IoAlert } from "react-icons/io5";

import useTheme from "hooks/useTheme";

const TransactionFailedModal = ({ isOpen, setIsOpen, modalInfo }) => {
	const { appLanguage, themeColor } = useTheme();

	return (
		<Transition appear show={isOpen} as={Fragment}>
			<Dialog as="div" className="relative z-10" onClose={() => setIsOpen(false)}>
				<Transition.Child
					as={Fragment}
					enter="ease-out duration-300"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="ease-in duration-200"
					leaveFrom="opacity-100"
					leaveTo="opacity-0"
				>
					<div className={`fixed inset-0 ${themeColor?.bg} bg-opacity-30`} />
				</Transition.Child>

				<div className="fixed inset-0 overflow-y-auto">
					<div className="flex min-h-full items-center justify-center p-4 text-center">
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0 scale-95"
							enterTo="opacity-100 scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 scale-100"
							leaveTo="opacity-0 scale-95"
						>
							<Dialog.Panel className="w-full max-w-lg transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
								<div className="flex flex-col w-full items-center">
									<IoAlert className={`w-fit text-5xl ${themeColor?.text}`} />

									<div className="flex flex-col w-full items-center justify-center space-y-7">
										<Dialog.Title
											as="h3"
											className={`flex flex-col items-center font-medium leading-6 ${themeColor?.text} space-y-1`}
										>
											<p className={`text-lg ${themeColor?.text}`}>{modalInfo?.title}</p>
											<p className={`text-xs ${themeColor?.text}`}>{modalInfo?.["sub-title"]}</p>
										</Dialog.Title>
										<p className={`text-xs text-center ${themeColor?.text}`}>{modalInfo?.message}</p>
									</div>
								</div>

								<div className="w-full flex mt-4 space-x-3 justify-end">
									<button
										type="button"
										className={`inline-flex justify-center rounded-md border px-4 py-2 text-sm font-medium text-white ${themeColor?.bg}`}
										onClick={() => setIsOpen(false)}
									>
										{appLanguage?.close}
									</button>
								</div>
							</Dialog.Panel>
						</Transition.Child>
					</div>
				</div>
			</Dialog>
		</Transition>
	);
};

export default TransactionFailedModal;
